import React from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";
import Providers from "../components/providers/Providers";
import CreateProvider from "../components/providers/CreateProvider";
import { ProtectedRoute } from "../helpers/ProtectedRoute";
import LegacyRouteRedirect from "../helpers/LegacyRouteRedirect";
import EditProvider from "../components/providers/EditProvider";
import PaymentsProviderOne from "../components/finance/PaymentsProviderOne";
const ProvidersRoutes = ({ match: { url } }) => (
  <Switch>
    <Route path={`${url}/`} exact component={Providers} />
    <ProtectedRoute
      path={`${url}/create`}
      rols={["manager"]}
      component={CreateProvider}
    />
    <ProtectedRoute
      path={`${url}/edit/:provider`}
      rols={["manager"]}
      component={EditProvider}
    />
    <ProtectedRoute
      path={`${url}/:id/payments-provider/:provider`}
      rols={["manager"]}
      component={PaymentsProviderOne}
    />
    <LegacyRouteRedirect />
  </Switch>
);

ProvidersRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(ProvidersRoutes);
